'use client';

export { default } from './Zoom';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Zoom/index.js
// module id = 574
// module chunks = 25